import { jsxs as l, jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12.0581 21.6465C11.5333 21.6465 10.9985 21.6073 10.444 21.5287C6.12659 20.9102 2.69048 17.4934 2.09634 13.2126C1.4923 8.87285 3.76983 4.71969 7.77037 2.89347L8.48334 2.56946L9.46367 3.80658L8.96855 4.42514C7.41389 6.1728 6.73063 8.37212 7.0178 10.65C7.42379 13.9097 9.97859 16.6588 13.2166 17.3265C14.2465 17.5425 14.9495 17.5719 15.8309 17.4345L17.1578 17.2283L16.9597 18.5439C16.9498 18.6618 17.0092 18.9956 17.0884 19.1821L17.4449 19.9872L16.6726 20.4291C15.2466 21.244 13.7316 21.6465 12.068 21.6465H12.0581ZM5.16606 7.67501C4.21544 9.19686 3.78964 11.0427 4.057 12.9377C4.53231 16.3054 7.33467 19.0938 10.7312 19.5847C11.8897 19.7516 12.9691 19.7025 13.9692 19.4374C13.6028 19.3981 13.2265 19.3392 12.8106 19.2509C8.7507 18.4163 5.56215 14.9799 5.04723 10.8954C4.9086 9.79578 4.94821 8.71576 5.16606 7.67501Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M20.0789 17.4443L18.4154 16.3839C18.5045 16.2464 18.6035 16.109 18.6926 15.9715C19.2472 15.1762 19.8215 14.3515 19.8215 11.8184C19.8215 9.71723 18.9996 7.74374 17.5043 6.26117C16.0091 4.7786 14.0187 3.96367 11.8996 3.96367C10.7708 3.96367 9.68152 4.19931 8.64177 4.66078L7.82978 2.87383C9.12699 2.29455 10.4935 2 11.8996 2C14.5436 2 17.029 3.02111 18.9006 4.87678C20.7721 6.73245 21.802 9.19686 21.802 11.8184C21.802 14.9701 20.9801 16.1483 20.3166 17.0908C20.2374 17.2086 20.1483 17.3265 20.069 17.4443H20.0789Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M18.653 22C16.8112 22 15.306 20.5174 15.306 18.6814C15.306 16.8454 16.8013 15.3628 18.653 15.3628C20.5047 15.3628 22 16.8454 22 18.6814C22 20.5174 20.5047 22 18.653 22ZM18.653 17.0908C17.7618 17.0908 17.0488 17.8076 17.0488 18.6814C17.0488 19.5552 17.7717 20.272 18.653 20.272C19.5343 20.272 20.2572 19.5552 20.2572 18.6814C20.2572 17.8076 19.5343 17.0908 18.653 17.0908Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.8703 11.0722C15.9641 11.0722 16.8508 10.193 16.8508 9.10849C16.8508 8.02399 15.9641 7.14482 14.8703 7.14482C13.7766 7.14482 12.8899 8.02399 12.8899 9.10849C12.8899 10.193 13.7766 11.0722 14.8703 11.0722Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
